import { render, staticRenderFns } from "./BooleanIconTableField.vue?vue&type=template&id=32f12e70&scoped=true&"
import script from "./BooleanIconTableField.vue?vue&type=script&lang=js&"
export * from "./BooleanIconTableField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f12e70",
  null
  
)

export default component.exports